var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image != null)?_c('div',{class:_vm.topClasses},[_c('img',{ref:"imgElement",attrs:{"src":_vm.imageSrc,"alt":_vm.image.altText}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }